import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getOsName } from '../../../common/name-formatter/get-os-name';
import { getArchName } from '../../../common/name-formatter/get-arch-name';
import { SettingsGroup, SettingsItem } from '../../settings-group/settings-group';
import styles from './auto-installed-tools-preview.css';
export function AutoInstalledToolsPreview(props) {
    const { tools, buildArch, buildOs } = props;
    return (_jsx(SettingsGroup, { groupName: "Auto installed tools", children: tools.map(tool => (_jsxs(SettingsItem, { children: [_jsx("div", { className: styles.toolName, children: tool.name }), _jsxs("div", { className: styles.toolOs, children: ["OS: ", getOsName(buildOs)] }), _jsxs("div", { className: styles.toolArch, children: ["Arch: ", getArchName(buildArch)] })] }, `${tool.appType}-${tool.build}`))) }));
}
